export default __webpack_public_path__ + "static/whatsapp-4ba01ee1516f9a3736f4959ecb20a797.png";